// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1UQJX","search":"Settings_search__3fI6D","filter":"Settings_filter__F31QS"};